module.exports = __webpack_public_path__ + "img/invoice_ali_icon.17a03900.png";